import {
  AppFetcher,
  AppIcon,
  AppInfoList,
  AppPage,
  AppWidget,
} from '@launchpad';
import { AppPadding } from '@launchpad/components/widgets/AppPadding';
import moment from 'moment';
import React from 'react';
import { AppBadge } from '@launchpad/components/typography';
import { currency } from '@launchpad/util/NumberHelper';
import { Link } from 'react-router-dom';
import BreadcrumbHelper from '@launchpad/util/BreadcrumbHelper';
import StipLogModel from '../../models/StipLogModel';
import { getBadgeTypeForStipLogStatus } from '../../utils/stipLogs.utils';

const JsonPreview = (props) => {
  return (
    <pre
      style={{
        whiteSpace: 'pre-wrap',
        textAlign: 'left',
        background: '#333',
        padding: 10,
        borderRadius: 5,
        color: 'white',
      }}
    >
      {JSON.stringify(props.json, null, 2)}
    </pre>
  );
};

const StipLogDetails = (props) => {
  BreadcrumbHelper.setCrumbs([
    {
      label: 'STIP Logs',
      link: '/stip-logs/list',
    },
  ]);
  BreadcrumbHelper.addCrumb('STIP Log Details');
  return (
    <AppFetcher
      model={StipLogModel}
      id={props.match.params.id}
      isIdInUrl
      renderContent={(record) => {
        const details = [
          {
            label: 'Created At',
            value: moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss.SSS'),
          },
          {
            label: 'Transaction ID',
            value: record.transactionId,
          },
          {
            label: 'Transaction reference',
            value: record.transactionReference || '-',
          },
          {
            label: 'Card Token',
            value: record.paymentDeviceToken,
          },
          {
            label: 'Account Number',
            value: record.accountNumber,
          },
          {
            label: 'Amount',
            value: currency(record.amount, record.currency),
          },
          {
            label: 'Status',
            value: (
              <AppBadge
                text={record.status}
                type={getBadgeTypeForStipLogStatus(record.status)}
              />
            ),
          },
          {
            label: 'Created',
            value: moment(record.created).format('DD/MM/YYYY HH:mm:ss'),
          },
          {
            label: 'Approved',
            value: (
              <AppIcon
                name={record.approved ? 'fa.check' : 'fa.times'}
                style={{
                  fontSize: 20,
                  color: record.approved ? '#4caf50' : '#b74343',
                }}
              />
            ),
          },
          {
            label: 'Approved by Temenos',
            value: (
              <AppIcon
                name={record.approvedByTemenos ? 'fa.check' : 'fa.times'}
                style={{
                  fontSize: 20,
                  color: record.approvedByTemenos ? '#4caf50' : '#b74343',
                }}
              />
            ),
          },
          {
            label: 'Approved by Pannovate',
            value: (
              <AppIcon
                name={record.approvedByPannovate ? 'fa.check' : 'fa.times'}
                style={{
                  fontSize: 20,
                  color: record.approvedByPannovate ? '#4caf50' : '#b74343',
                }}
              />
            ),
          },
        ];

        const finalResponse = [
          {
            label: 'Final Response',
            value: <JsonPreview json={record?.finalResponse} />,
          },
          {
            label: 'Final Response Time',
            value: `${record.finalResponseTime}ms`,
          },
          {
            label: 'Final Response Sent At',
            value: `${
              record.finalResponseAt
                ? moment(Number(record.finalResponseAt)).format(
                    'DD/MM/YYYY HH:mm:ss.SSS'
                  )
                : '-'
            }`,
          },
          {
            label: 'Final Response Source',
            value: `${record.finalResponseSource}`,
          },
        ];

        const fundingResponse = [
          {
            label: 'Funding Response Time',
            value: `${record.fundingResponseTime || '-'}ms`,
          },
          {
            label: 'Funding Response Sent At',
            value: `${
              record.fundingFinishedAt
                ? moment(Number(record.fundingFinishedAt)).format(
                    'DD/MM/YYYY HH:mm:ss.SSS'
                  )
                : '-'
            }`,
          },
          {
            label: 'Funding Response',
            value: <JsonPreview json={record?.fundingResponse} />,
          },
        ];

        const balanceEnquiryResponse = [
          {
            label: 'Balance Enquiry Response Time',
            value: `${record.balanceEnquiryResponseTime || '-'}ms`,
          },
          {
            label: 'Balance Enquiry Response Sent At',
            value: `${
              record.balanceEnquiryFinishedAt
                ? moment(Number(record.balanceEnquiryFinishedAt)).format(
                    'DD/MM/YYYY HH:mm:ss.SSS'
                  )
                : '-'
            }`,
          },
          {
            label: 'Balance Enquiry Response',
            value: <JsonPreview json={record?.balanceEnquiryResponse} />,
          },
        ];
        return (
          <AppPage title="STIP Log Details" icon="list">
            <div className="row">
              <div className="col-sm-6">
                <AppWidget title="Basic info">
                  <AppPadding>
                    <AppInfoList items={details} />
                  </AppPadding>
                </AppWidget>
              </div>
              <div className="col-sm-6">
                <AppWidget title="Final Response">
                  <AppPadding>
                    <AppInfoList items={finalResponse} />
                  </AppPadding>
                </AppWidget>

                {record?.cachedBalanceValue ? (
                  <div style={{ marginTop: 15 }}>
                    <AppWidget title="Cached balance">
                      <AppPadding>
                        <JsonPreview json={record?.cachedBalanceValue} />
                      </AppPadding>
                    </AppWidget>
                  </div>
                ) : null}

                <div style={{ marginTop: 15 }}>
                  <AppWidget title="Connected Entities">
                    <AppPadding>
                      {record.paymentDeviceId && (
                        <Link
                          style={{ marginRight: 10 }}
                          to={`/cards/details/${record.paymentDeviceId}`}
                          className="button-info"
                        >
                          Card
                        </Link>
                      )}
                      {record.transactionId && (
                        <Link
                          style={{ marginRight: 10 }}
                          to={`/transaction/details/${record.transactionId}`}
                          className="button-info"
                        >
                          Transaction
                        </Link>
                      )}
                      {record.accountId && (
                        <Link
                          style={{ marginRight: 10 }}
                          to={`/accounts/details/${record.accountId}`}
                          className="button-info"
                        >
                          Account
                        </Link>
                      )}
                    </AppPadding>
                  </AppWidget>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-sm-6">
                <AppWidget title="Funding Response">
                  <AppPadding>
                    <AppInfoList items={fundingResponse} />
                  </AppPadding>
                </AppWidget>
              </div>
              <div className="col-sm-6">
                <AppWidget title="Balance Enquiry Response">
                  <AppPadding>
                    <AppInfoList items={balanceEnquiryResponse} />
                  </AppPadding>
                </AppWidget>
              </div>
            </div>
            <div style={{ marginTop: 15 }} />
          </AppPage>
        );
      }}
    />
  );
};

export default StipLogDetails;
